export default __webpack_public_path__ + "static/media/qrcode-site-2048w.e359f1b4.png";